import styled from "styled-components";
import { space } from "metabase/styled-components/theme";

export const IconContainer = styled.div`
  padding-right: ${space(0)};
`;
